// As abas que ficam no endereço e os endereços antigos que levam a elas (PROMPT 211). Puro, para testar sem tela.

export const ABAS_DO_PLANEJAMENTO = [
  ['estrategista', 'Estrategista'], ['calendario', 'Calendário'], ['canais', 'Canais'], ['concorrencia', 'Concorrência'],
  ['resultados', 'Resultados'], ['estudos', 'Estudos de caso'], ['relatorios', 'Relatórios'],
];
export const ABAS_DO_BRAND_BRAIN = ['intelligence', 'base', 'assets', 'clone', 'aprendi', 'mapa'];

const valida = (lista, aba, padrao) => (lista.includes(aba) ? aba : padrao);
export const abaDoPlanejamento = (aba) => valida(ABAS_DO_PLANEJAMENTO.map(([v]) => v), aba, 'estrategista');
export const abaDoBrandBrain = (aba) => valida(ABAS_DO_BRAND_BRAIN, aba, 'intelligence');

/** A busca do endereço com a aba trocada; o resto dela fica. */
export const comAba = (busca, aba) => {
  const nova = new URLSearchParams(busca);
  nova.set('aba', aba);
  return nova;
};

// O Planejador do LOTE 207 chamava "plano" o que hoje é Calendário e "metricas" o que hoje é Resultados.
const ABA_ANTIGA_DO_PLANEJADOR = { plano: 'calendario', metricas: 'resultados' };

/** /planejador, /planejador?aba=x e /planejador/x levam à aba certa do Planejamento MKT; o padrão era o plano. */
export const destinoDoPlanejador = (caminho, busca) => {
  const nova = new URLSearchParams(busca);
  const pedida = String(caminho || '').split('/').filter(Boolean)[1] || nova.get('aba') || 'plano';
  const aba = ABA_ANTIGA_DO_PLANEJADOR[pedida] || pedida;
  nova.set('aba', ABAS_DO_PLANEJAMENTO.some(([v]) => v === aba) ? aba : 'calendario');
  return `/planning?${nova}`;
};

/** /brand-kit com o que veio na busca; /aprendi e /assets abrem a aba deles. */
export const destinoDoBrandBrain = (busca, aba) => {
  const nova = new URLSearchParams(busca);
  if (aba) nova.set('aba', aba);
  const texto = nova.toString();
  return texto ? `/brand-brain?${texto}` : '/brand-brain';
};
